module.exports = __webpack_public_path__ + "static/media/receipt3.682fc5fd.png";